<template>
  <div>
    <StatsComponent :interns="interns" />
    <StatsSidebar />
    <EditorSidebar />
  </div>
</template>

<script>
import StatsComponent from './StatsComponent'
import StatsSidebar from './StatsSidebar'
import EditorSidebar from './EditorSidebar.vue'
import { AgeOption } from '@/models/Content'

export default {
  props: {
    interns: { default: false, type: Boolean }
  },
  components: { StatsComponent, StatsSidebar, EditorSidebar },
  data() {
    return {}
  },
  created() {
    AgeOption.fetch(this.$store.getters.specialty)
  }
}
</script>
